// Every list and modal in here swallowed failures — some closed silently, some
// did nothing at all — so an operator could not tell a rejected save from a
// successful one. This turns an axios error into one line worth showing.
//
// 5xx and network faults get their own wording: "invalid input" and "the server
// is down" are not the same problem for whoever has to act on it.

// Only a message written for a human gets shown. These APIs are old and mix Thai
// user-facing text with English internals ("Not found", "Cannot read properties
// of null", raw Joi output, plain HTTP phrases from the error handler's
// `err.message || httpStatus[status]` default), and there is no flag telling them
// apart — so the screen is kept Thai by requiring Thai. Anything else falls back
// to the caller's wording; the English detail is still in the network tab.
function thaiOnly(message) {
  return typeof message === 'string' && /[\u0E00-\u0E7F]/.test(message) ? message.trim() : ''
}

export function apiMessage(err, fallback = 'เกิดข้อผิดพลาด กรุณาลองใหม่') {
  const response = err && err.response
  if (!response) return 'เชื่อมต่อระบบไม่ได้ กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองใหม่'
  const data = response.data || {}
  const message = thaiOnly(data.message) ||
    thaiOnly(data.system_response && data.system_response.message)
  if (message) return message
  if (response.status === 401) return 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่'
  if (response.status === 403) return 'ไม่มีสิทธิ์ทำรายการนี้'
  if (response.status >= 500) return 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง'
  return fallback
}

export default apiMessage
